export class PartnerUser {
  constructor(id, created, email, username, lastActivity, isAdmin, lastPartnerAccess, permissions) {
    this.id = id;
    this.created = created;
    this.email = email;
    this.username = username;
    this.lastActivity = lastActivity;
    this.isAdmin = isAdmin;
    this.lastPartnerAccess = lastPartnerAccess;
    this.permissions = permissions;
  }
  get isGeovelo() {
    return this.email.indexOf('@geovelo.fr') > -1;
  }
}